module.exports = __webpack_public_path__ + "media/Video 127.06c4c847.mp4";